/* eslint-disable @typescript-eslint/no-explicit-any */
import { compose } from 'ramda';
import { connect } from 'react-redux';

import { withApplicationContext } from '../../containers/ApplicationContext';
import { getPanoramaAvailable } from '../../selectors/getPanoramaAvailable';
import { selectIsRouteMapTabEnabled } from '../../selectors/selectIsRouteMapTabEnabled';
import { TMapTab, changeTab } from '../../store/map_tabs';
import { IApplicationContext } from '../../types/applicationContext';
import { IOfferMapTabsProps, OfferMapTabs } from './tabs';

import type { DispatchReduxAction, IState } from '../../store';

type TStoreProps = Pick<
  IOfferMapTabsProps,
  | 'activeTab'
  | 'offer'
  | 'specialProject'
  | 'specialPromoInfo'
  | 'subdomain'
  | 'isPanoramaAvailable'
  | 'isRouteMapAvailable'
>;
type TDispatchProps = Pick<IOfferMapTabsProps, 'changeTab'>;
type TOfferMapTabsOwnProps = Omit<IOfferMapTabsProps, keyof IOwnProps | keyof TStoreProps | keyof TDispatchProps>;

export function mapContextToProps({ config }: IApplicationContext): IOwnProps | any {
  const panoramaEnabled = config.get<boolean>('panoramaBanner.enabled') || false;
  const panoramaUrl = config.get<string>('panoramaBannerUrl') || null;

  return {
    citiesWithPanoramaId: config.get<number[]>('suburban.citiesWithPanoramaID') || null,
    isPanoramaBannerEnabled: Boolean(panoramaEnabled && panoramaUrl),
  };
}

export interface IOwnProps {
  citiesWithPanoramaId: number[];
  isPanoramaBannerEnabled: boolean;
}

export function mapStateToProps(state: IState, ownProps: IOwnProps): TStoreProps {
  const { citiesWithPanoramaId, isPanoramaBannerEnabled } = ownProps;

  return {
    activeTab: state.mapTabs.activeTab,
    offer: state.offerData.offer,
    specialProject: state.offerData.specialProject,
    specialPromoInfo: state.specialPromoInfo,
    subdomain: state.pageData.subdomain,
    isPanoramaAvailable: getPanoramaAvailable(state, citiesWithPanoramaId, isPanoramaBannerEnabled),
    isRouteMapAvailable: selectIsRouteMapTabEnabled(state),
  };
}

export function mapDispatchToProps(dispatch: DispatchReduxAction): TDispatchProps {
  return {
    changeTab: (tab: TMapTab) => dispatch(changeTab(tab)),
  };
}

export function mergeProps(
  stateProps: TStoreProps,
  dispatchProps: TDispatchProps,
  ownProps: TOfferMapTabsOwnProps & IOwnProps,
): IOfferMapTabsProps {
  return {
    ...stateProps,
    ...dispatchProps,
    ...ownProps,
  };
}

export const OfferMapTabsContainer = compose(
  withApplicationContext(mapContextToProps),
  connect<TStoreProps, TDispatchProps, TOfferMapTabsOwnProps & IOwnProps>(
    mapStateToProps,
    mapDispatchToProps,
    mergeProps,
  ),
)(OfferMapTabs);
